interface IRouteMatchLike {
  loaderData: unknown;
}

interface IWithPage {
  page?: { hideSiteHeader?: boolean | null } | null;
}

const hasPage = (data: unknown): data is IWithPage =>
  typeof data === "object" && data !== null && "page" in data;

export const isSiteHeaderHidden = (matches: IRouteMatchLike[]): boolean =>
  matches.some(
    ({ loaderData }) =>
      hasPage(loaderData) && loaderData.page?.hideSiteHeader === true
  );
